
import React from 'react';
import { Belt } from './types';

interface BeltCirclesProps {
  belts: Belt[];
  beltSpacing?: number;
  onBeltClick?: (belt: Belt) => void;
}

export const BeltCircles: React.FC<BeltCirclesProps> = ({ belts, beltSpacing = 230, onBeltClick }) => {
  return (
    <>
      {belts.map((belt, index) => {
        // Meso timeline uses the original spacing
        const startX = 40;
        const position = startX + (index * beltSpacing);
        
        return (
          <div 
            key={index}
            className="absolute transform -translate-x-1/2 top-1/2 -translate-y-1/2 z-20 cursor-pointer hover:scale-105 transition-transform"
            style={{ left: position }}
            onClick={() => onBeltClick && onBeltClick({ ...belt })}
            role="button"
            tabIndex={0}
            aria-label={`${belt.name} belt`}
          >
            {/* Belt square with more rounded corners */}
            <div 
              className="rounded-2xl border-2 border-black flex items-center justify-center text-sm font-medium shadow-md"
              style={{ 
                backgroundColor: belt.color,
                color: belt.color === '#000000' ? '#ffffff' : '#000000',
                height: '80px',
                width: '80px'
              }}
            >
              {belt.name}
            </div>
          </div>
        );
      })}
    </>
  );
};
